<div class="registration-details-view-container" *ngIf="registrationObject" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%"
           *ngIf="registrationObject.insuranceCompany.registrationIdTypes.length > 0">
        <div fxFlex="100">
          <mat-card fxLayoutGap="15px">
            <div fxLayout="row">
              <h3>Identyfikatory</h3>
            </div>
            <div fxLayout="row wrap">
              <ng-container *ngFor="let type of registrationObject.insuranceCompany.registrationIdTypes">

                <div fxFlex="48" *ngIf="type!=REGISTRATION_ID_TYPE_SENT &&  type!=REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT &&  type!=REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION">
                  <app-detail
                    *ngIf="registrationIdTypes.hasOwnProperty(type)" fxFlex="100"
                    fxLayout="column"
                    [header]="registrationIdTypes[type].name"
                    [limitedAccess]="registrationIdTypes[type].secured && !(userPermissionss | async).registration.id_import"
                  >
                    <ng-container>
                      <mat-chip-list
                        *ngIf="registrationIdTypes[type].valueType === 'string'">
                        <ng-container
                          *ngFor="let value of registrationIdentifiers[type]?.value.split(', '); let last = last"
                        >
                          <mat-chip *ngIf="
                          (activeIdentifierEdit !==  type)
                          &&
                          value && last"
                                    color="accent" selected
                                    matTooltip="{{value}}" (click)="copyMessage(value)"
                                    class="id-mat">{{ (value?.length > 35) ? (value | slice:0:35) + '...' : (value) }}
                          </mat-chip>
                          <mat-chip *ngIf="
                          activeIdentifierEdit !==  type &&
                          value && !last &&
                          registrationIdTypes[type].key !=='manager'
                          && registrationIdTypes[type].key !=='manager_email'
                          && registrationIdTypes[type].key !=='manager_phone'
                          && registrationIdTypes[type].key !=='generali_agro_ic_email'
                          && registrationIdTypes[type].key !=='generali_agro_ic_manager'
                          && registrationIdTypes[type].key !=='generali_agro_ic_phone' " (click)="copyMessage(value)"
                                    matTooltip="{{value}}"
                          >{{ (value.length > 35) ? (value | slice:0:35) + '...' : (value) }}
                          </mat-chip>


                        </ng-container>
                        <div fxFlex="100" *ngIf="modifyActive && activeIdentifierEdit ===  type">
                          <app-chips-input-control *ngIf=" type ==='manager'
                      || type ==='manager_email'
                      || type ==='manager_phone'
                      || type ==='generali_agro_ic_email'
                      || type ==='generali_agro_ic_manager'
                      || type ==='generali_agro_ic_phone' "
                                                   [lastTest]="true"
                                                   [arrayControl]="getControl(registrationIdForms[type].formGroup, 'value')"
                                                   class="id-mat"
                          ></app-chips-input-control>
                          <app-chips-input-control *ngIf=" type !=='manager'
                       && type !=='manager_email'
                       && type !=='manager_phone'
                       && type !=='generali_agro_ic_email'
                       && type !=='generali_agro_ic_manager'
                       && type !=='generali_agro_ic_phone' "
                                                   [lastTest]="false"
                                                   [arrayControl]="getControl(registrationIdForms[type].formGroup, 'value')"
                                                   class="id-mat"
                          ></app-chips-input-control>
                        </div>

                      </mat-chip-list>


                      <ng-container *ngIf="
                      activeIdentifierEdit !==  type &&
                      registrationIdentifiers.hasOwnProperty(type) &&
                      registrationIdTypes[type]?.valueType !== 'string'">
                        <app-detail-bool
                          [value]="registrationIdentifiers[type].value.toLowerCase() === 'tak'"></app-detail-bool>

                      </ng-container>
                    </ng-container>

                    <ng-container *ngIf="
                      activeIdentifierEdit !==  type &&
                      !registrationIdentifiers.hasOwnProperty(type) && registrationIdTypes[type].valueType !== 'string'">
                      <app-detail-bool [value]="false"></app-detail-bool>

                    </ng-container>


                    <ng-container *ngIf="modifyActive &&
                     activeIdentifierEdit ===  type &&
                     registrationIdTypes[type].valueType !== 'string'">
                      <app-slide-toggle
                        [control]="getControl(registrationIdForms[type].formGroup, 'value')"
                        [trueValue]="'Tak'"
                        [falseValue]="'Nie'"
                      ></app-slide-toggle>
                    </ng-container>
                  </app-detail>

                  <div fxLayout="row" fxLayoutAlign="end end" *ngIf="registrationIdTypes.hasOwnProperty(type)"
                       [fxHide]="registrationIdTypes[type].secured && !(userPermissionss | async).registration.id_import">
                    <div class="id-button" fxLayout="row"  *ngIf="(userPermissionss | async).registration.write">
                      <button *ngIf="!modifyActive
                        " (click)="editOne(type)"
                              mat-icon-button color="primary">
                        <mat-icon>create</mat-icon>
                      </button>
                      <button class="id-button"
                              [disabled]="processingRequest"
                              *ngIf="modifyActive
                      && type === activeIdentifierEdit
                        "
                              (click)="save(type)" mat-icon-button color="primary">
                        <mat-icon>save</mat-icon>
                      </button>

                      <button class="id-button"
                              *ngIf="modifyActive
                      && type === activeIdentifierEdit"
                              (click)="cancel()"
                              mat-icon-button color="primary">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>



